<ckeditor [editor]="ckEditor" [data]="data" (change)="onChange($event)" [config]="config"></ckeditor>
